import React from 'react'
import ReactTimeago from 'react-timeago'

interface ReactTimeAgoProps {
  date: string
}
const CustomTimeAgo = ({ date }: ReactTimeAgoProps) => {
  const formatter = (value: number, unit: string, suffix: string) =>
    `${value} ${value == 1 ? unit : `${unit}s`}`

  return <ReactTimeago date={date} formatter={formatter} />
}

export default CustomTimeAgo
